import React from "react";
import "./css/Ptemp.css";
export default function Ptemp(props)
{
    return (
        <div className="ptemplate">
            <h1>{props.name}</h1>
            <h4>{props.buildwith}</h4>
            <a 
                href={props.link} 
                target="_blank"
                rel="noopener noreferrer"
                value="Link"
            ><i class="fa fa-link"></i></a>
            <span>{props.description}</span>
        </div>
    )
}